import {TableColumn} from "../../../Component/Model/Table/Table";
import {DefaultCell} from "../../../Component/Common/Components/DataTable/DefaultCell";
import {ValidationReview} from "../../../Component/Model/Dto/Staging/ValidationReview";
import {ImportValidationFailure} from "../../../Component/Model/Dto/Staging/ImportValidationFailure";
import {ValidationFailuresCell} from "./ValidationFailuresCell";
import {failureReason} from "./ValidationFailureLabels";

interface ValidationReviewEmployeeRow {
    name: string;
    employeeCode: string;
    idNumber: string;
    failures: ImportValidationFailure.Dto[];
}

interface ValidationReviewEmployeeTable {
    columns: Array<TableColumn>;
    rows: Array<ValidationReviewEmployeeRow>;
}

export function PayrollValidationReviewMapper(employees: ValidationReview.Employee[]): ValidationReviewEmployeeTable {
    const columns = [
        {Header: 'Employee', accessor: 'name', Cell: ({value}: any) => <DefaultCell value={value}/>, disableSortBy: true},
        {Header: 'Employee Code', accessor: 'employeeCode', Cell: ({value}: any) => <DefaultCell value={value}/>, disableSortBy: true},
        {Header: 'ID Number', accessor: 'idNumber', Cell: ({value}: any) => <DefaultCell value={value}/>, disableSortBy: true},
        {Header: 'Failures', accessor: 'failures', Cell: ValidationFailuresCell, disableSortBy: true},
    ];

    const rows = employees.map(employee => ({
        name: `${employee.firstname ?? ""} ${employee.surname ?? ""}`.trim(),
        employeeCode: employee.employeeCode ?? "",
        idNumber: employee.idNumber ?? "",
        failures: employee.failures,
    }));

    return {columns, rows};
}

interface UnattributedFailureRow {
    section: string;
    reason: string;
}

interface UnattributedFailureTable {
    columns: Array<TableColumn>;
    rows: Array<UnattributedFailureRow>;
}

export function PayrollUnattributedFailuresMapper(failures: ImportValidationFailure.Dto[]): UnattributedFailureTable {
    const columns = [
        {Header: 'Section', accessor: 'section', Cell: ({value}: any) => <DefaultCell value={value}/>, disableSortBy: true},
        {Header: 'Failure', accessor: 'reason', Cell: ({value}: any) => <DefaultCell value={value}/>, disableSortBy: true},
    ];

    const rows = failures.map(failure => ({
        section: failure.section ?? "",
        reason: failureReason(failure),
    }));

    return {columns, rows};
}
